/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Calm_True_Calf_MeltInputs */

const en_calm_true_calf_melt = /** @type {(inputs: Calm_True_Calf_MeltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Managers of ${i?.displayName}`)
};

const de_calm_true_calf_melt = /** @type {(inputs: Calm_True_Calf_MeltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manager von ${i?.displayName} ...`)
};

/**
* | output |
* | --- |
* | "Managers of {displayName}" |
*
* @param {Calm_True_Calf_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_true_calf_melt = /** @type {((inputs: Calm_True_Calf_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_True_Calf_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_true_calf_melt(inputs)
	return de_calm_true_calf_melt(inputs)
});